import { render } from "./GuideMenu.vue?vue&type=template&id=4ac652a9&scoped=true"
import script from "./GuideMenu.vue?vue&type=script&lang=js"
export * from "./GuideMenu.vue?vue&type=script&lang=js"

import "./GuideMenu.vue?vue&type=style&index=0&id=4ac652a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac652a9"]])

export default __exports__